// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9n-0";
export var optionCard = "_9n-1";